import {
  CreateProjectPlanTicketRequest,
  CreateProjectPlanTicketResponse,
  IfBulkUpdateTicketsRequest,
  IfBulkUpdateTicketsResponse,
  BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  BulkUpdateTicketsOfIfAttributeDesignReviewResponse,
  UpdateComponentAttributeTicketStatusesRequest,
  UpdateComponentAttributeTicketStatusesResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface TicketsRestResource {
  createProjectPlanTicket(
    request: CreateProjectPlanTicketRequest,
  ): Promise<CreateProjectPlanTicketResponse>;
  ifBulkUpdateTickets(
    request: IfBulkUpdateTicketsRequest,
  ): Promise<IfBulkUpdateTicketsResponse>;
  bulkUpdateTicketsOfIfAttributeDesignReview(
    request: BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  ): Promise<BulkUpdateTicketsOfIfAttributeDesignReviewResponse>;
  updateComponentAttributeTicketStatuses(
    request: UpdateComponentAttributeTicketStatusesRequest,
  ): Promise<UpdateComponentAttributeTicketStatusesResponse>;
}

const REST_RESOURCE_NAME = {
  CREATE_PROJECT_PLAN_TICKETS: `/tickets/project-plan`,
  IF_BULK_UPDATE_TICKETS: `/tickets/if-common`,
  BULK_UPDATE_IF_ATTRIBUTE_DESIGN_REVIEW: `/tickets/if-attribute-design-review`,
  COMPONENT_ATTRIBUTE: `/tickets/component-attribute`,
};

/**
 * PUT /tickets/project-plan
 */
const createProjectPlanTicket = restResourceRequester<
  CreateProjectPlanTicketRequest,
  CreateProjectPlanTicketResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.CREATE_PROJECT_PLAN_TICKETS}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /if-bulk-update-tickets
 */
const ifBulkUpdateTickets = restResourceRequester<
  IfBulkUpdateTicketsRequest,
  IfBulkUpdateTicketsResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.IF_BULK_UPDATE_TICKETS}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /bulk-update-tickets-of-if-attribute-design-review
 */
const bulkUpdateTicketsOfIfAttributeDesignReview = restResourceRequester<
  BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  BulkUpdateTicketsOfIfAttributeDesignReviewResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.BULK_UPDATE_IF_ATTRIBUTE_DESIGN_REVIEW}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /tickets/component-attribute
 */
const updateComponentAttributeTicketStatuses = restResourceRequester<
  UpdateComponentAttributeTicketStatusesRequest,
  UpdateComponentAttributeTicketStatusesResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME.COMPONENT_ATTRIBUTE}`;
  },
  (request) => JSON.stringify(request),
);

export const ticketsRestResource: TicketsRestResource = {
  createProjectPlanTicket: createProjectPlanTicket,
  ifBulkUpdateTickets: ifBulkUpdateTickets,
  bulkUpdateTicketsOfIfAttributeDesignReview:
    bulkUpdateTicketsOfIfAttributeDesignReview,
  updateComponentAttributeTicketStatuses:
    updateComponentAttributeTicketStatuses,
};
